export const CONTROL_BAR_HEIGHT = 34;

// Default height for an audio <wistia-player> when the author hasn't set an
// explicit height. Audio has no intrinsic media height (the <audio> element is
// 0px and the UI is absolutely positioned), so without this the host collapses
// to a bare control bar — most visibly after a video→audio replaceWith. Matches
// FULL_SIZED_PLAYER_MIN_HEIGHT in players/vulcanV2Player/audio/constants.js so
// the audio UI renders its full-sized layout. Author CSS (e.g. the inline
// `height` the standard embed codes set) still overrides this.
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const AUDIO_DEFAULT_HEIGHT = 218;

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const DEFAULT_ASPECT = 16 / 9;
